// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"828e2363","453":"49cad6a1","455":"d8281211","977":"ac484002"}[chunkId] + ".chunk.js";
};